// Copyright (c) 2016 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import criteria from './criteria';
import formatting from './formatting';
import report from './report';
import reportIsScrollable from '../../shared/reducers/report-is-scrollable';
import showNoResultsFound from '../../shared/reducers/show-no-results-found';
import views from './views';

export const getCombinedReducers = () =>
    combineReducers({
        busyCounter,
        criteria,
        formatting,
        report,
        reportIsScrollable,
        showNoResultsFound,
        views
    });



// WEBPACK FOOTER //
// ./src/reports/dealer-transfer-history/reducers/index.js